import { Center, Heading } from "@chakra-ui/react";
import React from "react";

export default function Gallery() {
  return (
    <div>
      <Heading color="white" p={10}>
        <Center>Memories Will Be Added Soon...</Center>
      </Heading>
    </div>
  );
}
